var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c('Home',{attrs:{"msg":"Welcome"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }